var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#3C3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 10.8334C14.9415 10.8334 13.6807 12.1084 13.6807 13.6667L13.6665 36.3334C13.6665 37.8917 14.9273 39.1667 16.4857 39.1667H33.4998C35.0582 39.1667 36.3332 37.8917 36.3332 36.3334V19.3334L27.8332 10.8334H16.4998ZM26.4165 20.75V12.9584L34.2082 20.75H26.4165Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveFiles);
export default __webpack_public_path__ + "static/media/driveFiles.960a9176599296c4ff8ed3a8fa08926c.svg";
export { ForwardRef as ReactComponent };